import axios from 'axios';
import { Message } from 'element-ui';
import { getToken, setToken, removeToken } from '@/utils/auth';

const config = {
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 300000, // Request timeout
  withCredentials: false, // 访问线上api时axios发送跨域请求时需要设置这个参数
};
// Create axios instance

if (process.env.NODE_ENV === 'development') {
  config.baseURL = process.env.VUE_APP_BASE_API; // api 的 base_url
  // 开发环境
} else if (process.env.NODE_ENV === 'production') {
  // 生产环境
  config.baseURL = process.env.VUE_APP_URL + process.env.VUE_APP_BASE_API; // 这里是线上api请求地址
}

const service = axios.create(config);

// Request intercepter
service.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + getToken(); // Set JWT token
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    if (response.headers.authorization) {
      setToken(response.headers.authorization);
      response.data.token = response.headers.authorization;
    }

    return response.data;
  },
  error => {
    let message = error.message;
    if (error.response.status === 401) {
      location.href = process.env.VUE_APP_ENTRY_URL;
      removeToken();
    }

    if (error.response.data) {
      if (error.response.data.errors) {
        message = error.response.data.errors;
      } else if (error.response.data.error) {
        message = error.response.data.error;
      } else if (error.response.data.message) {
        message = error.response.data.message;
      }
    }

    Message({
      showClose: true,
      message: message,
      type: 'error',
      duration: 10 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
